export default function loginScope() {
  let environment = window?.PROMCOMM?.ENVIRONMENT || 'dev'
  environment = environment === 'local' ? 'dev' : environment
  return `https://${environment}.promcomm.sainsburys.co.uk/access`
}
